import React, { useContext } from "react";

import { LEGAL_PRIVACY_BLOCKS } from "../../constants/legalAndPrivacy";
import { LegalAndPrivacyContext } from "../../context/LegalAndPrivacyContext";
import CopyrightInfringementNotification from "./copyrightInfringementNotification/CopyrightInfringementNotification";
import LegalAndPrivacy from "./legalAndPrivacy/LegalAndPrivacy";
import MedicalPoliciesAndPayment from "./medicalPoliciesAndPayment/MedicalPoliciesAndPayment";
import NonDiscriminationNotice from "./nonDiscriminationNotice/NonDiscriminationNotice";
import WebAndMobilePrivacy from "./webAndMobilePrivacy/WebAndMobilePrivacy";
import TOU from "./webAndMobileTOU/TOU";

const LegalAndPrivacyPage = () => {
  const { currentPage } = useContext(LegalAndPrivacyContext);
  const renderCurrentPage = () => {
    switch (currentPage) {
      case LEGAL_PRIVACY_BLOCKS.LEGAL_AND_PRIVACY:
        return <LegalAndPrivacy />;
      case LEGAL_PRIVACY_BLOCKS.TERMS_OF_USE:
        return <TOU />;
      case LEGAL_PRIVACY_BLOCKS.PRIVACY_STATEMENT:
        return <WebAndMobilePrivacy />;
      case LEGAL_PRIVACY_BLOCKS.COPYRIGHT_INFRINGEMENT_NOTIF:
        return <CopyrightInfringementNotification />;
      case LEGAL_PRIVACY_BLOCKS.NON_DISCRIMINATION_NOTICE:
        return <NonDiscriminationNotice />;
      case LEGAL_PRIVACY_BLOCKS.MEDICAL_AND_PAYMENT_POLICIES:
        return <MedicalPoliciesAndPayment />;
      default:
        return null;
    }
  };

  return renderCurrentPage();
};

export default LegalAndPrivacyPage;
